import { useEffect, useState } from 'react';
import { useForm } from '@abyss/web/hooks/useForm';
import { BreadcrumbService } from '@src/api/common/BreadcrumbService';
import { PageTitleService } from '@src/api/common/PageTitleService';
import { Breadcrumbs, Title } from './PageInfo';
import { CookieService } from '@src/api/common/CookieService';

const ApplyTokenController = () => {
  const { UpdateBreadcrumb } = BreadcrumbService();
  const { UpdatePageTitle } = PageTitleService();
  const [fieldsDisabled, setFieldsDisabled] = useState<boolean>(false);

  const form = useForm({
    defaultValues: {
      token: '',
      baseUrl: '',
    },
  });

  const DataSource = {
    ApplyMaskedCookie: async () => {
      const cookie = CookieService.GetCookie('authToken');
      const baseUrl = CookieService.GetCookie('baseUrl');
      if(baseUrl) {
        await form.setValue('baseUrl', baseUrl);
      }
      if (cookie) {
        let maskedValue = '';
        for (let index = 0; index < cookie.length; index++) {
          maskedValue += '*';
        }
        await form.setValue('token', maskedValue);
        await setFieldsDisabled(true);
      }
      else {
        await form.setValue('token', '');
        await setFieldsDisabled(false);
      }
    },
  };

  const Action = {
    Init: async () => {
      await UpdateBreadcrumb(Breadcrumbs);
      await UpdatePageTitle(Title);
      await Action.Load();
    },
    Load: async () => {
      DataSource.ApplyMaskedCookie();
    },
    ApplyClick: async () => {
      if (!fieldsDisabled) {
        const token = await form.getValues().token;
        const baseUrl = await form.getValues().baseUrl;
        await CookieService.SaveCookie('authToken', token);
        await CookieService.SaveCookie('baseUrl', baseUrl);
        await DataSource.ApplyMaskedCookie();
      }
      else {
        await CookieService.DeleteCookie('authToken');
        await CookieService.DeleteCookie('baseUrl');
        await form.reset();
      }
      await setFieldsDisabled(!fieldsDisabled);
    },
  };

  useEffect(() => {
    Action.Init();
  }, []);

  return {
    form,
    Action,
    fieldsDisabled,
  };
};

export { ApplyTokenController };
